export default {
  title: '商品類別資料',
  schema: {
    type: 'Object',
    contents: {
      key: {
        name: '商品類別',
        type: 'String',
        unique: true,
        required: true,
      },
      code: {
        name: '類別代碼',
        type: 'String',
      },
      weightRatio: {
        name: '運費分攤比',
        type: 'Number',
      },
      sortOrder: {
        name: '排序',
        type: 'Number',
      },
      hideInOptions: {
        name: '在選項隱藏',
        type: 'Boolean',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  list: {
    ui: {
      fields: [
        { path: 'key', width: 150 },
        { path: 'code', width: 150 },
        { path: 'weightRatio' },
        { path: 'sortOrder' },
        { path: 'hideInOptions' },
      ],
    },
  },
  edit: {
    ui: {
      form: {
        name: 'formEditor',
        fields: [
          ['key', 'code'],
          ['weightRatio', 'sortOrder'],
          ['hideInOptions'],
        ],
      },
    },
  },
}
